/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_Address_CityInputs */

const en_clients_field_address_city = /** @type {(inputs: Clients_Field_Address_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`City`)
};

const pt_br2_clients_field_address_city = /** @type {(inputs: Clients_Field_Address_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cidade`)
};

/**
* | output |
* | --- |
* | "City" |
*
* @param {Clients_Field_Address_CityInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_address_city = /** @type {((inputs?: Clients_Field_Address_CityInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_Address_CityInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_address_city(inputs)
	return pt_br2_clients_field_address_city(inputs)
});